export default __webpack_public_path__ + "static/media/music_marimba_hi_on.0a7fa5b7.mp3";